import { Menu } from 'lucide-react';
import gpsLogo from '@/GPS-logo-2022.svg';

/**
 * Mobile Top-Bar (< md): Hamburger öffnet den Sidebar-Drawer, schmales
 * Logo. Desktop blendet die Leiste aus (dort übernimmt die Sidebar).
 */
export function MobileTopBar({ onMenu }: { onMenu: () => void }) {
  return (
    <header className="flex h-12 shrink-0 items-center gap-2 border-b border-gray-200 bg-white px-3 pt-[env(safe-area-inset-top)] md:hidden">
      <button
        type="button"
        onClick={onMenu}
        className="rounded p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
        title="Menü öffnen"
      >
        <Menu className="h-5 w-5" />
      </button>
      <img src={gpsLogo} alt="GPS" className="h-7 w-auto" />
    </header>
  );
}